"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopupConnection = void 0;
const connection_manager_1 = require("./connection-manager");
const constants_1 = require("./core/constants");
const types_1 = require("./core/types");
const react_1 = require("react");
const usePopupConnection = ({ enabled = true, platform = types_1.Platform.UNKNOWN, widthPx = constants_1.DEFAULT_POPUP_WIDTH_PX, heightPx = constants_1.DEFAULT_POPUP_HEIGHT_PX, } = {}) => {
    const [exportedConnection, setExportedConnection] = (0, react_1.useState)(undefined);
    const connectionManagerRef = (0, react_1.useRef)(new connection_manager_1.ConnectionManager(platform).onConnectionUpdated((connection) => {
        setExportedConnection(connection === null || connection === void 0 ? void 0 : connection.export());
    }));
    const open = (0, react_1.useCallback)((url, nonce) => {
        connectionManagerRef.current.open({
            heightPx,
            nonce,
            url,
            widthPx,
        });
    }, [connectionManagerRef, widthPx, heightPx]);
    const close = (0, react_1.useCallback)(() => {
        connectionManagerRef.current.close();
    }, [connectionManagerRef]);
    (0, react_1.useEffect)(() => {
        if (enabled) {
            connectionManagerRef.current.initialize();
        }
        else {
            connectionManagerRef.current.tearDown();
        }
    }, [connectionManagerRef]);
    return {
        close,
        connection: exportedConnection,
        open,
    };
};
exports.usePopupConnection = usePopupConnection;
//# sourceMappingURL=use-popup-connection.js.map